export const usersPermission = [
  {
    name: "view user",
    slug: "VIEW_USER",
  },
  {
    name: "create user",
    slug: "CREATE_USER",
  },
  {
    name: "update user",
    slug: "UPDATE_USER",
  },
  {
    name: "delete user",
    slug: "DELETE_USER",
  },
];
export const projectPermission = [
  {
    name: "Add TENANT",
    slug: "ADD_TENANT",
  },
  {
    name: "View TENANT",
    slug: "VIEW_TENANT",
  },
  {
    name: "Book TENANT",
    slug: "BOOK_TENANT",
  },
];
export const payrolePermission = [
  {
    name: "View Payrole",
    slug: "VIEW_PAYROLE",
  },
  {
    name: "Add Payrole",
    slug: "ADD_PAYROLE",
  },
  {
    name: "Edit Payrole",
    slug: "EDIT_PAYROLE",
  },
];
export const reportsPermission = [
  {
    name: "View Reports",
    slug: "VIEW_REPORTS",
  },
];
export const permissions = [
  {
    label: "User",
    list: usersPermission,
  },
  {
    label: "Tenant",
    list: projectPermission,
  },
  {
    label: "Payrole",
    list: payrolePermission,
  },
  {
    label: "Reports",
    list: reportsPermission,
  },
];
export const allPermissions = [
  ...usersPermission,
  ...payrolePermission,
  ...projectPermission,
  ...reportsPermission,
];
